module.exports = __webpack_public_path__ + "assets/img/558a-np.svg";